import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    now: new Date('2019-08-31T23:40:00.000Z').getTime(),
    timeIsPlaying: true
  },
  getters: {
    now(state){
      return state.now
    },
    timeIsPlaying(state){
      return state.timeIsPlaying
    }
  },
  mutations: {
    currentTimeUpdated(state, newTime){
      state.now = newTime
    },
    stopTime(state){
      state.timeIsPlaying = false
    },
    startTime(state){
      state.timeIsPlaying = true
    }
  },
  actions: {
    startTime(context, callback) {
      setInterval(() => {
        if (context.state.timeIsPlaying){
          context.commit('currentTimeUpdated', context.state.now + 600000)
          callback()
        }
      }, 3000)
    }
  }
})